import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/ru';
import 'dayjs/locale/tr';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/zh';
import 'dayjs/locale/en';
// 扩展语种中dayjs部分的支持
if (window._PANDA_EXUI) {
    Object.keys(window._PANDA_EXUI).forEach((lang) => {
        const extraUiDayjs = window._PANDA_EXUI[lang].dayjs;
        if (extraUiDayjs) {
            dayjs.locale(typeof extraUiDayjs === 'function' ? extraUiDayjs() : extraUiDayjs, undefined, true);
        }
    });
}
